import React from "react";
import Contact from "./Contact";
// import { address_type } from "./interfaces";

const Address = ({ addresses, contacts }) => {
  if (addresses && addresses.length > 0) {
    const primary_address = addresses.find((p) => p.is_default) || addresses[0];
    const other_addresses = addresses.filter(
      (p) => p.address_id !== primary_address.address_id
    );
    // console.log(other_addresses);

    if (contacts === undefined || contacts.length === 0) {
      contacts = primary_address.contacts;
    }
    return (
      <address>
        {primary_address.address_line1}
        <br />
        {primary_address.address_line2}
        <br />
        {primary_address.office_name}, {primary_address.district}
        <br />
        {primary_address.state_name}, Pin - {primary_address.pincode}
        <br />
        {contacts && contacts.length > 0 && <Contact contacts={contacts} />}
      </address>
    );
  } else return <></>;
};

export default Address;
